import React from 'react';
import PropTypes from 'prop-types';

import VisualizerRoomListItem from '../VisualizerProductListItem/VisualizerRoomListItem';

import { StyledGrid } from './VisualizerProductListStyles';

var designYourOwnRoom = {
  name: 'Design Your Own',
  url: '#/',
  image: 'https://cdn.shopify.com/s/files/1/1765/3959/files/design_your_own.png'
};

var VisualizerRoomList = function VisualizerRoomList(props) {
  return React.createElement(
    StyledGrid,
    null,
    React.createElement(VisualizerRoomListItem, {
      key: 'Design Your Own',
      room: designYourOwnRoom,
      isStaging: props.isStaging,
      designYourOwn: true,
      handleCategoryActive: props.handleCategoryActive,
      categoryActive: props.categoryActive
    }),
    props.rooms.map(function (room) {
      var filteredItems = room.size && (props.selectedFilter === '' || room.size === props.selectedFilter.replace('twin xl', 'twin-xl'));
      if (filteredItems) {
        return React.createElement(VisualizerRoomListItem, {
          key: room.name,
          room: room,
          isStaging: props.isStaging,
          designYourOwn: false
        });
      } else {
        return null;
      }
    })
  );
};

VisualizerRoomList.propTypes = {
  selectedFilter: PropTypes.string,
  rooms: PropTypes.array,
  categoryTitle: PropTypes.string,
  maxItems: PropTypes.number,
  selectedProducts: PropTypes.array,
  handleProductSelection: PropTypes.func,
  isStaging: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  categoryActive: PropTypes.object.isRequired,
  handleCategoryActive: PropTypes.func.isRequired
};

export default VisualizerRoomList;